import React, {useState} from "react";

import './App.scss';

//containers
//components
import {Header, About, Work, Skills, Footer} from "./container";

import {Navbar} from "./components";
import Cv from "./components/cv";

function App() {

    const [isActive, setIsActive] = useState(false)


    const showCvHandler = () => {
        setIsActive(true)
    }


    return (
        <div className="app">
            {isActive === true ? (<Cv/>) :
                (
                    <>

                        <Navbar setIsActive={showCvHandler}/>
                        <Header/>
                        <About/>
                        <Work/>
                        <Skills/>
                        <Footer/>
                    </>
                )}


        </div>
    );
}

export default App;
